var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 16.2583L16.259 12L12.0007 7.74168L10.7757 8.96668L12.934 11.125H7.62565V12.875H12.934L10.7757 15.0333L12.0007 16.2583ZM12.0007 23.6667C10.4062 23.6667 8.89926 23.3604 7.47982 22.7479C6.06037 22.1354 4.82079 21.2993 3.76107 20.2396C2.70135 19.1799 1.86523 17.9403 1.25273 16.5208C0.640234 15.1014 0.333984 13.5945 0.333984 12C0.333984 10.3861 0.640234 8.86945 1.25273 7.45001C1.86523 6.03057 2.70135 4.79584 3.76107 3.74584C4.82079 2.69584 6.06037 1.86459 7.47982 1.25209C8.89926 0.639593 10.4062 0.333344 12.0007 0.333344C13.6145 0.333344 15.1312 0.639593 16.5506 1.25209C17.9701 1.86459 19.2048 2.69584 20.2548 3.74584C21.3048 4.79584 22.1361 6.03057 22.7486 7.45001C23.3611 8.86945 23.6673 10.3861 23.6673 12C23.6673 13.5945 23.3611 15.1014 22.7486 16.5208C22.1361 17.9403 21.3048 19.1799 20.2548 20.2396C19.2048 21.2993 17.9701 22.1354 16.5506 22.7479C15.1312 23.3604 13.6145 23.6667 12.0007 23.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.36d98f643979cacc3065a959f731a8e1.svg";
export { ForwardRef as ReactComponent };